import { useState, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import API from '../../utils/API';
import constants from '../../utils/constants';
import ImportModalActivate from './ImportModalActivate';
import Toast from '../../components/Toast/Toast';

function SupportActivate(props) {
  const navigate = useNavigate();
  const { user } = props;
  const permissionIds = user.permissions.map((permission) => permission.id);
  
  if (!permissionIds.includes(constants.permissionIds.support)) {
    navigate('/forbidden');
  }

  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [modalError, setModalError] = useState('');
  // Single user activate
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  // User modal field validation states
  const [submitted, setSubmitted] = useState(false);
  const [emailValid, setEmailValid] = useState(false);

  // Reset import modal
  const resetImportModalRef = useRef(null);
  const handleResetImportModal = () => {
    if (resetImportModalRef.current) {
      resetImportModalRef.current();
    }
  };

  // Close modal
  const closeModal = (modalId) => {
    if (!modalId) {
      // Handle general modal close if needed
      return;
    }
    const modal = document.getElementById(modalId);
    if (modal) {
      const closeButton = modal.querySelector('.btn-close');
      if (closeButton) {
        closeButton.click();
      }
    }
    handleResetImportModal();
  };

  // Handle form change
  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }, []);

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    console.log('Activating user:', formData.email,'password:', formData.password);
    API.activateUser(formData.email, formData.password)
      .then((res) => {
        setEmailValid(true);
        setSuccess(<FormattedMessage id="USER_ACTIVATED_SUCCESS" />);
        setModalError('');
        closeModal('activateUserModal');
      }).catch((err) => {
        console.error(err);
        setEmailValid(false);
        const message = err.response?.data?.message ?? 'USER_ACTIVATED_FAIL';
        setError(<FormattedMessage id={message} />);
        if (message === 'USER_NOT_FOUND') {
          setModalError(<FormattedMessage id="SUBMIT_ERROR" />);
        }
      });
  };

  const importModalProps = {
    setResetImportModalRef: (resetFunc) => { resetImportModalRef.current = resetFunc; },
    setSuccess,
    modalError,
    setModalError,
    closeModal,
  };

  return (
    <div>
      <div className="title"><FormattedMessage id="USER_IMPORT_AND_ACTIVATION" /></div>
      <div className="card" style={{ padding: '16px'}}>
        <div className="importUsersActivatedTitle pb-3 fs-6 fw-bold"><FormattedMessage id="IMPORT_USERS_FROM_CSV" defaultMessage="Import Users From CSV" /></div>
        <button
          type="button"
          className="btn btn-filled"
          style={{ width: "20%"}}
          data-bs-toggle="modal"
          data-bs-target="#import-modal"
          onClick={handleResetImportModal}
        > 
          <FormattedMessage id="IMPORT_USERS_ACTIVATED" defaultMessage="Import Users (Activated)" />
        </button>
        <div className="activateUserInfo">
          <div className="activateUserInfoTitle pt-4 pb-2 fs-6 fw-bold"><FormattedMessage id="ACTIVATE_USER" defaultMessage="Activate User" /></div>
          <div className='emailSection w-25'>
            <label htmlFor='emailLabel' className='col-form-label'>
              <FormattedMessage id='EMAIL' />
            </label>
            <input
              onChange={handleChange}
              value={formData.email}
              name='email'
              className={`form-control ${submitted && (emailValid ? 'is-valid' : 'is-invalid')}`}
            />
            {submitted && !emailValid && <div className="invalid-feedback"><FormattedMessage id="USER_NOT_FOUND" /></div>}
          </div>
          <div className='passwordSection mb-4 w-25'>
            <label htmlFor='passwordLabel' className='col-form-label'>
              <FormattedMessage id='PASSWORD' />
            </label>
            <input
              onChange={handleChange}
              value={formData.password}
              name='password'
              className='form-control'
            />
          </div>
          <button className='btn save-btn' type='button' onClick={handleSubmit}>
            <FormattedMessage id='SUBMIT' />
          </button>
        </div>
      </div>
      <ImportModalActivate {...importModalProps} />
      <Toast
        success={success}
        error={error}
        setSuccess={setSuccess}
        setError={setError}
      />
    </div>
  )
  
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(SupportActivate)
